import createReducer from "../createReducer";
import { IAuthState, IUserTypes } from "./types";
import { authHandlers } from "./handlers";

const AuthInitialState: IAuthState = {
    user: null,
    userType: IUserTypes.GUEST,
    isLoading: false,
    token: null,
    refresh_token: null,
    errors: null,
};

export default createReducer(AuthInitialState, authHandlers);
